/**
 * Sprogsider — arabisk indhold (/ar). RTL.
 *
 * REGLER: ingen priser eller varigheder skrives her — de hentes fra courseGroups.js.
 * Hver faktuel påstand skal kunne føres tilbage til `sources`.
 */

const FS = (label, path) => ({ label, url: `https://www.fstyr.dk${path}` });

const AUTHORITY = "هيئة المرور الدنماركية (Færdselsstyrelsen)";

export const ar = {
  code: "ar",
  htmlLang: "ar",
  dir: "rtl",
  locale: "ar_DK",
  numLocale: "en-GB",
  nativeName: "العربية",
  currency: "DKK",
  ui: {
    notice:
      "هذه الصفحة بالعربية. بقية موقع votra.dk بالدنماركية، اتصل بنا على ‎+45 55 29 28 28‏ وسنساعدك بالعربية.",
    indexTitle: "دورات النقل بالعربية في الدنمارك | Votra",
    indexDescription:
      "دورة مشغّل النقل (فوجنمان) للشاحنة وسيارة النقل الصغيرة: دراسة ذاتية والاختبار عند Votra مع مترجم فوري، وشهادة سائق الفان، ومعلومات سائق التاكسي، بالعربية.",
    indexH1: "دورات النقل بالعربية",
    indexIntro:
      "شركة Votra Danmark ApS هي مركز تدريب دنماركي في مجال النقل، مقرها في سوبورغ (Søborg) ولديها مركز اختبارات في رينغستيد (Ringsted). نحن مدرجون في قائمة هيئة المرور الدنماركية (Færdselsstyrelsen) لمقدّمي اختبار مشغّلي نقل البضائع المعتمدين، ونوفّر مترجمًا فوريًا في الاختبار عندما تؤدّيه بالعربية أو الإنجليزية أو الأوكرانية.",
    coursesHeading: "الدورات التي يمكنك أداؤها بالعربية",
    openCourse: "اقرأ المزيد",
    answerHeading: "الإجابة المختصرة",
    facts: {
      heading: "معلومات أساسية",
      course: "الدورة",
      provider: "مقدّم الدورة",
      delivery: "طريقة التنفيذ",
      duration: "المدة",
      priceDa: "السعر، الاختبار بالدنماركية",
      priceForeign: "السعر، بالعربية (مع مترجم فوري)",
      priceAmu: "سعر AMU (إذا كنت مستحقًا)",
      venue: "المكان",
      certificate: "ما تحصل عليه",
      entry: "شروط القبول",
      authority: "الجهة المختصة",
    },
    dates: {
      headingExam: "مواعيد الاختبارات القادمة",
      headingCourse: "مواعيد الدورات القادمة",
      empty: "لا توجد مواعيد منشورة حاليًا. اتصل بنا وسنجد لك موعدًا.",
      seats: "مقعد متاح",
      full: "مكتمل",
      signUp: "التسجيل",
      language: "اللغة",
      languages: { da: "الدنماركية", en: "الإنجليزية", ar: "العربية", uk: "الأوكرانية", fa: "الفارسية" },
      allInLanguage: "اعرض جميع المواعيد المتاحة مع ترجمة فورية بالعربية",
      calendarNotice: "أنت ترى فقط المواعيد التي تُقدَّم فيها هذه الدورة مع ترجمة فورية بالعربية.",
      calendarNoticeAll: "أنت ترى فقط المواعيد التي تتوفّر فيها ترجمة فورية بالعربية.",
      calendarBack: "العودة إلى الصفحات العربية",
    },
    faqHeading: "أسئلة وأجوبة",
    sourcesHeading: "المصادر الرسمية",
    cta: {
      heading: "جاهز للبدء؟",
      text: "اتصل بنا وسنجيب على أسئلتك بالعربية، أو أرسل لنا بريدًا إلكترونيًا وسنعاود الاتصال بك.",
      call: "اتصل ‎+45 55 29 28 28",
      email: "راسلنا بالبريد الإلكتروني",
      signUpForm: "املأ نموذج التسجيل",
      danishPage: "انظر صفحة الدورة الكاملة بالدنماركية",
    },
    danishRequiredBadge: "اللغة الدنماركية شرط قانوني لهذه الدورة",
    fvuCta: "انظر دورة Votra للتحضير للدنماركية (FVU المستوى 2)",
    backHome: "Votra بالدنماركية",
    otherLangs: "لغات أخرى",
    breadcrumb: "العربية",
  },
  courses: {
    "haulier-truck": {
      slug: "رخصة-نقل-بضائع-شاحنة",
      metaTitle: "دورة مشغّل النقل للشاحنة بالعربية | Votra",
      metaDescription:
        "كن مدير نقل معتمدًا لنقل البضائع بشاحنات تزيد عن 3.500 كجم. دراسة ذاتية عبر الإنترنت واختبار كتابي عند Votra، مع مترجم فوري وثلاث محاولات.",
      h1: "دورة مشغّل النقل للشاحنة (godsvognmand)، بالعربية",
      short: "أدِر شركة نقل بضائع بشاحنات تزيد عن 3.500 كجم. دراسة ذاتية + اختبار كتابي عند Votra.",
      answer:
        "تؤهّلك دورة مشغّل نقل البضائع الدنماركية (godsvognmandsuddannelsen) لأن تُعتمد مديرًا للنقل في شركة تحمل ترخيصًا لنقل البضائع لحساب الغير بشاحنة أو مقطورة تزيد عن 3.500 كجم. في Votra تدرس عبر الإنترنت بالوتيرة التي تناسبك، ثم تؤدّي الاختبار الكتابي عندنا: شركة Votra Danmark ApS مدرجة في قائمة هيئة المرور الدنماركية لمقدّمي الاختبار المعتمدين. يشمل السعر الاختبار بثلاث محاولات، ويُوفَّر مترجم فوري عند أداء الاختبار بالعربية.",
      facts: {
        course: "دورة مشغّل نقل البضائع للشاحنة (godsvognmandsuddannelsen)",
        delivery: "دراسة ذاتية بمواد تعليمية عبر الإنترنت + اختبار كتابي عند Votra",
        duration: "دراسة ذاتية بوتيرتك الخاصة. الشرط القانوني: 144 حصة على الأقل، كل حصة 60 دقيقة",
        venue: "الاختبار عند Votra في رينغستيد (Sct. Hansgade 9، الطابق الثاني) وسوبورغ",
        certificate: "شهادة الكفاءة المهنية لنقل البضائع، أساس الاعتماد كمدير نقل",
        entry: "أن تكون قد أتممت 18 عامًا وأن تعرف استخدام برنامج جدول بيانات مثل Excel",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "كيف تسير الدورة",
          paragraphs: [
            "لا يوجد حضور في قاعة الدرس. تحصل على مواد تعليمية إلكترونية تغطي جميع المواضيع الواردة في الملحق 1 من اللائحة الدنماركية لنقل البضائع (bekendtgørelsen om godskørsel)، تقرأها وقت ما يناسبك، ثم تؤدّي الاختبار في الموعد الذي تختاره.",
            "يقضي الشرط القانوني بأن تغطي الدورة 144 حصة على الأقل من 60 دقيقة، بما يشمل حتى 15 دقيقة راحة. هذا هو المستوى الذي تغطيه المواد، لكن أنت من يحدّد الوتيرة، ولا يوجد التزام بالحضور.",
          ],
        },
        {
          h2: "الاختبار",
          paragraphs: [
            "الاختبار كتابي. تُعِدّه وتنظّمه هيئة المرور الدنماركية ويُؤدّى في النظام الإلكتروني للاختبارات الخاص بالهيئة. ولأن Votra مقدّم اختبار معتمد، فإنك تؤدّيه في مقرّنا في رينغستيد أو سوبورغ، وليس عند طرف ثالث.",
            "يتكوّن الاختبار من 60 سؤال اختيار من متعدد و6 حالات عملية، ويلزم تحقيق 65 ٪ من مجموع الاختبار للنجاح. يشمل سعر الدورة ثلاث محاولات، ونحن من يسجّلك في الاختبار.",
            "عند أداء الاختبار بالعربية توفّر Votra مترجمًا فوريًا. لهذا السبب يكون السعر بلغة غير الدنماركية أعلى.",
          ],
        },
        {
          h2: "ما يشمله الاختبار",
          paragraphs: [
            "جميع المجالات الإحدى عشر في الملحق 1: القانون المدني، والقانون التجاري، وقانون العمل والتشريعات الاجتماعية، والتشريعات الضريبية، والإدارة التجارية والمالية للشركة، والوصول إلى السوق، والمعايير الفنية وتشغيل المركبات، والسلامة المرورية، ونشاط تأجير السائقين، وتقنيات التفاوض، وإدارة السلامة المرورية.",
            "القائمة الكاملة بكل بنودها الفرعية منشورة في صفحة الدورة بالدنماركية، وهي المنهج الرسمي، لا قائمة تسويقية.",
          ],
        },
        {
          h2: "بعد النجاح",
          paragraphs: [
            "تغطي الشهادة شرط الكفاءة المهنية. وقبل أن تصدر هيئة المرور الترخيص، يجب أن تستوفي الشركة أيضًا شروط التأسيس، والمتانة المالية (شرط رأس المال)، وشروط الأجور والعمل، وحسن السيرة، وأن تعيّن مدير نقل معتمدًا.",
            "الرسم 1.500 كرونة دنماركية لترخيص المجموعة الأوروبية و1.500 كرونة لكل نسخة مصدّقة، ويُمنح الترخيص لمدة تصل إلى 10 سنوات، وتستهدف الهيئة البتّ في الطلب خلال 60 يومًا.",
          ],
        },
      ],
      faq: [
        { q: "هل يمكنني أداء الاختبار بالعربية؟", a: "نعم. توفّر Votra مترجمًا فوريًا عند أداء الاختبار بالعربية أو الإنجليزية أو الأوكرانية، والمترجم مشمول في السعر الخاص باللغات غير الدنماركية." },
        { q: "هل هناك حضور في قاعة الدرس؟", a: "لا. تدرس المواد الإلكترونية بوتيرتك ثم تؤدّي الاختبار عند Votra. لا التزام بالحضور ولا موعد بدء ثابت." },
        { q: "كيف يتكوّن الاختبار؟", a: "60 سؤال اختيار من متعدد و6 حالات عملية. يلزم 65 ٪ من مجموع الاختبار للنجاح، ويُؤدّى كتابيًا في النظام الإلكتروني لهيئة المرور داخل مقر Votra." },
        { q: "كم محاولة أحصل عليها؟", a: "ثلاث محاولات مشمولة في سعر الدورة." },
        { q: "أين يُعقد الاختبار؟", a: "عند Votra في رينغستيد (Sct. Hansgade 9، الطابق الثاني) أو في سوبورغ. شركة Votra Danmark ApS مدرجة في قائمة هيئة المرور لمقدّمي الاختبار المعتمدين لمشغّلي نقل البضائع." },
        { q: "ما هي شروط القبول؟", a: "أن تكون قد أتممت 18 عامًا وأن تعرف استخدام برنامج جدول بيانات مثل Excel، لأن الجزء المالي يُحسب في جدول بيانات." },
        { q: "هل أحتاج رخصة قيادة شاحنة؟", a: "لا. دورة مشغّل النقل تتعلّق بإدارة شركة النقل وتشغيلها. رخصة القيادة وتدريب السائقين شرطان على من يقود المركبة، لا على مدير النقل." },
        { q: "هل الشهادة كافية للحصول على الترخيص؟", a: "لا. هي تغطي الكفاءة المهنية. ويجب على الشركة أيضًا استيفاء شروط التأسيس والمتانة المالية وشروط الأجور والعمل وحسن السيرة." },
      ],
      sources: [
        FS("اختبارات مشغّلي نقل البضائع، Votra مدرجة في قائمة المقدّمين", "/privat/chauffoeruddannelser/uddannelser-i-godskoersel/proever-for-godsvognmaend"),
        FS("عن نقل البضائع (هيئة المرور الدنماركية)", "/erhverv/gods/om-godskoersel"),
        { label: "اللائحة الدنماركية لنقل البضائع، الملحق 1", url: "https://www.retsinformation.dk/eli/lta/2018/1222" },
      ],
    },

    "haulier-van": {
      slug: "رخصة-نقل-بضائع-فان",
      metaTitle: "دورة مشغّل النقل لسيارة الفان بالعربية | Votra",
      metaDescription:
        "تأهّل للحصول على ترخيص نقل البضائع لحساب الغير بسيارات فان بين 2.500 و3.500 كجم. دراسة ذاتية عبر الإنترنت، واختبار عند Votra، ومترجم فوري، وثلاث محاولات.",
      h1: "دورة مشغّل النقل لسيارة الفان (vognmand til varebil)، بالعربية",
      short: "أدِر شركة نقل بضائع بسيارات فان بين 2.500 و3.500 كجم. دراسة ذاتية + اختبار عند Votra.",
      answer:
        "تمكّنك دورة مشغّل النقل لسيارة الفان من التقدّم للحصول على ترخيص نقل البضائع لحساب الغير بسيارة فان أو مقطورة يتراوح وزنها الإجمالي المسموح بين 2.500 كجم و3.500 كجم. في Votra تدرس عبر الإنترنت بوتيرتك، ثم تؤدّي الاختبار الكتابي عندنا في رينغستيد أو سوبورغ. يشمل السعر الاختبار بثلاث محاولات، ويُوفَّر مترجم فوري عند أداء الاختبار بالعربية.",
      facts: {
        course: "دورة مشغّل النقل لسيارة الفان (vognmandsuddannelsen til varebil)",
        delivery: "دراسة ذاتية بمواد تعليمية عبر الإنترنت + اختبار كتابي عند Votra",
        duration: "دراسة ذاتية بوتيرتك الخاصة. الشرط القانوني: 37 حصة على الأقل، كل حصة 60 دقيقة",
        venue: "الاختبار عند Votra في رينغستيد (Sct. Hansgade 9، الطابق الثاني) وسوبورغ",
        certificate: "شهادة الكفاءة المهنية لنقل البضائع بالفان، أساس ترخيص الفان",
        entry: "أن تكون قد أتممت 18 عامًا وأن تعرف استخدام برنامج جدول بيانات مثل Excel",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "كيف تسير الدورة",
          paragraphs: [
            "لا حضور في قاعة الدرس ولا موعد بدء ثابت. تحصل على المواد الإلكترونية التي تغطي جميع المواضيع الواردة في الملحق 2 من لائحة نقل البضائع، وتؤدّي الاختبار في الموعد الذي تختاره.",
            "الشرط القانوني للدورة هو 37 حصة على الأقل من 60 دقيقة، بما يشمل حتى 15 دقيقة راحة.",
          ],
        },
        {
          h2: "الاختبار",
          paragraphs: [
            "الاختبار كتابي، تُعِدّه هيئة المرور الدنماركية ويُؤدّى في النظام الإلكتروني للاختبارات الخاص بالهيئة. تعقد Votra الاختبار في مقرّها في رينغستيد وسوبورغ، ونحن من يسجّلك فيه.",
            "هو اختبار اختيار من متعدد يُحلّ على الحاسوب، ويجب أن تجيب إجابة صحيحة على 76 ٪ على الأقل من الأسئلة للنجاح. عدد الأسئلة تحدّده هيئة المرور ويُبلَّغ به عند التسجيل. ثلاث محاولات مشمولة في السعر.",
            "عند أداء الاختبار بالعربية توفّر Votra مترجمًا فوريًا، ولهذا يكون السعر بلغة غير الدنماركية أعلى.",
          ],
        },
        {
          h2: "فان أم شاحنة، ما الذي تحتاجه؟",
          paragraphs: [
            "ترخيص الفان يغطي نقل البضائع بسيارات فان بين 2.500 و3.500 كجم ويتطلّب 37 حصة على الأقل (الملحق 2). وإذا أردت نقل البضائع بشاحنة أو مقطورة تزيد عن 3.500 كجم، فأنت بحاجة إلى دورة الشاحنة التي يبلغ شرطها 144 حصة على الأقل (الملحق 1). والترخيصان لا يغطي أحدهما الآخر.",
          ],
        },
      ],
      faq: [
        { q: "هل يمكنني أداء الاختبار بالعربية؟", a: "نعم. توفّر Votra مترجمًا فوريًا عند أداء الاختبار بالعربية أو الإنجليزية أو الأوكرانية، وهو مشمول في السعر الخاص باللغات غير الدنماركية." },
        { q: "كيف يتكوّن الاختبار؟", a: "اختبار اختيار من متعدد يُحلّ على الحاسوب، وحدّ النجاح 76 ٪ من الإجابات الصحيحة. عدد الأسئلة تحدّده هيئة المرور ويُبلَّغ به عند التسجيل. ثلاث محاولات مشمولة." },
        { q: "هل هناك حضور في قاعة الدرس؟", a: "لا. تدرس عبر الإنترنت بوتيرتك ثم تؤدّي الاختبار عند Votra. لا التزام بالحضور ولا موعد بدء ثابت." },
        { q: "ما الأوزان التي يغطيها ترخيص الفان؟", a: "سيارات الفان والمقطورات التي يتراوح وزنها الإجمالي المسموح بين 2.500 كجم و3.500 كجم. وفوق ذلك تحتاج دورة الشاحنة (نقل البضائع)." },
        { q: "أين يُعقد الاختبار؟", a: "عند Votra في رينغستيد (Sct. Hansgade 9، الطابق الثاني) وفي سوبورغ." },
        { q: "ما هي شروط القبول؟", a: "أن تكون قد أتممت 18 عامًا وأن تعرف استخدام برنامج جدول بيانات مثل Excel." },
        { q: "هل الشهادة كافية للحصول على الترخيص؟", a: "لا. تطلب هيئة المرور أيضًا التأسيس والمتانة المالية وشروط الأجور والعمل وحسن السيرة قبل إصدار الترخيص." },
      ],
      sources: [
        FS("سيارات الفان، قواعد نقل البضائع التجاري", "/erhverv/varebil"),
        FS("دورات الفان (هيئة المرور الدنماركية)", "/privat/chauffoeruddannelser/varebilsuddannelser"),
        { label: "اللائحة الدنماركية لنقل البضائع، الملحق 2", url: "https://www.retsinformation.dk/eli/lta/2018/1222" },
      ],
    },

    "van-driver-basic": {
      slug: "شهادة-سائق-فان",
      metaTitle: "شهادة سائق الفان (VB GU) بالعربية | Votra",
      metaDescription:
        "الدورة التأهيلية الأساسية الإلزامية لسائقي الفان الذين ينقلون البضائع لحساب الغير. تمنحك شهادة سائق الفان، وصلاحيتها خمس سنوات.",
      h1: "الدورة التأهيلية الأساسية لسائق الفان (VB GU)، بالعربية",
      short: "الشهادة الإلزامية لقيادة سيارة فان تجاريًا. ثلاثة أيام، والاختبار مشمول.",
      answer:
        "VB GU هي الدورة التأهيلية الأساسية الإلزامية للسائقين الذين ينقلون البضائع لحساب الغير بسيارة فان. تمنحك شهادة سائق الفان الدنماركية (varebilschaufføruddannelsesbevis)، ويجب حملها أثناء القيادة وإظهارها عند طلب الشرطة. ينطبق الشرط إذا كنت تنقل بضائع لحساب الغير يزيد وزن القطعة الواحدة منها على 11 كجم، في سيارة فان أو مقطورة يتراوح وزنها الإجمالي المسموح بين 2.500 كجم و3.500 كجم.",
      facts: {
        course: "الدورة التأهيلية الأساسية لسائق الفان (VB GU)",
        delivery: "دورة حضورية تُنفَّذ مع شريكنا UCplus وتنتهي باختبار كتابي",
        duration: "3 أيام",
        venue: "UCplus سكوفلوندِه (Mileparken 12A)، مقر شريكنا",
        certificate: "شهادة تأهيل سائق الفان (VUB)، وصلاحيتها كقاعدة عامة خمس سنوات",
        entry: "لا شيء. لا توجد شروط مسبقة للمشاركة",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "من يحتاج إليها؟",
          paragraphs: [
            "السائقون الذين ينقلون بضائع لحساب الغير بسيارة فان، حيث يزيد وزن القطعة الواحدة على 11 كجم ويتراوح الوزن الإجمالي المسموح للفان أو المقطورة بين 2.500 كجم و3.500 كجم.",
            "إذا كنت تحمل بطاقة تأهيل السائق الزرقاء لفئة الرخصة C (شاحنة)، فلديك تلقائيًا الحقوق نفسها التي يتمتع بها حاملو شهادة سائق الفان.",
          ],
        },
        {
          h2: "الاختبار",
          paragraphs: [
            "تنتهي الدورة الأساسية باختبار كتابي من 20 سؤال اختيار من متعدد، لكل سؤال إجابة صحيحة واحدة. يجب أن تجيب إجابة صحيحة على 16 سؤالًا على الأقل، أي 76 ٪، للنجاح، ولديك 30 دقيقة. ويُمنح الممتحنون ذوو صعوبات القراءة الموثّقة 45 دقيقة.",
          ],
        },
        {
          h2: "الصلاحية والتجديد",
          paragraphs: [
            "صلاحية الشهادة خمس سنوات كقاعدة عامة. وللحفاظ عليها يجب إكمال دورة تجديد مدتها يومان، ولا يُؤدّى فيها اختبار. ولا يجوز لك متابعة قيادة الفان تجاريًا قبل إكمال دورة التجديد.",
            "ملاحظة: VB اختصار لكلمة varebil التي تعني سيارة فان. ولا علاقة لها بالباصات.",
          ],
        },
      ],
      faq: [
        { q: "هل VB GU دورة باصات؟", a: "لا. VB تعني varebil، أي سيارة فان بالدنماركية. VB GU دورة فان." },
        { q: "هل هناك اختبار، وكيف يتكوّن؟", a: "نعم. 20 سؤال اختيار من متعدد في 30 دقيقة، ويلزم 16 إجابة صحيحة على الأقل (76 ٪) للنجاح. ومع صعوبات قراءة موثّقة تحصل على 45 دقيقة." },
        { q: "ما مدة صلاحية الشهادة؟", a: "خمس سنوات كقاعدة عامة. بعدها تحتاج دورة التجديد لمدة يومين (VB EU) للحفاظ عليها." },
        { q: "هل هناك شروط قبول؟", a: "لا. لا توجد شروط مسبقة للمشاركة." },
        { q: "هل يمكنني أداؤها بالعربية؟", a: "نعم، ننفّذ الدورة بالعربية والإنجليزية والأوكرانية إلى جانب الدنماركية، لكن اللغات المتاحة تختلف من موعد إلى آخر. اتصل بنا على ‎+45 55 29 28 28‏ ونخبرك بالمتاح." },
      ],
      sources: [FS("دورات الفان (هيئة المرور الدنماركية)", "/privat/chauffoeruddannelser/varebilsuddannelser")],
    },

    "van-driver-refresher": {
      slug: "تجديد-شهادة-سائق-فان",
      metaTitle: "دورة تجديد شهادة سائق الفان (VB EU) بالعربية | Votra",
      metaDescription:
        "دورة التجديد التي تمتد يومين وتجدّد شهادة سائق الفان الدنماركية. بدون اختبار.",
      h1: "دورة تجديد شهادة سائق الفان (VB EU)، بالعربية",
      short: "جدّد شهادة سائق الفان في يومين. بدون اختبار.",
      answer:
        "VB EU هي دورة التجديد الإلزامية التي تجدّد شهادة سائق الفان الدنماركية (varebilschaufføruddannelsesbevis). مدة الدورة يومان ولا يوجد فيها اختبار. وإذا انتهت صلاحية شهادتك، فلا يجوز لك متابعة قيادة الفان تجاريًا قبل إكمال دورة التجديد.",
      facts: {
        course: "دورة تجديد شهادة سائق الفان (VB EU)",
        delivery: "دورة حضورية تُنفَّذ مع شريكنا UCplus. بدون اختبار",
        duration: "يومان",
        venue: "UCplus سكوفلوندِه (Mileparken 12A)، مقر شريكنا",
        certificate: "شهادة تأهيل سائق فان مُجدَّدة (VUB)",
        entry: "شهادة تأهيل سائق فان (VUB)",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "متى تحتاج إليها؟",
          paragraphs: [
            "صلاحية الشهادة خمس سنوات كقاعدة عامة. وقبل انتهائها تؤدّي دورة التجديد لمدة يومين فتُجدَّد الشهادة. ولا يوجد اختبار في دورة التجديد.",
            "إذا كنت غير متأكد من موعدك النهائي، فاتصل بنا وسنساعدك في إيجاد الموعد المناسب.",
          ],
        },
      ],
      faq: [
        { q: "هل هناك اختبار؟", a: "لا. لا يوجد اختبار في دورة التجديد." },
        { q: "ماذا أحتاج للمشاركة؟", a: "شهادة تأهيل سائق فان. وإذا انتهت صلاحيتها، فعليك أداء دورة التجديد لمدة يومين قبل استئناف القيادة التجارية." },
        { q: "هل VB EU دورة باصات؟", a: "لا. VB تعني varebil، سيارة فان." },
        { q: "هل يمكنني أداؤها بالعربية؟", a: "نعم، ننفّذها بالعربية والإنجليزية والأوكرانية إلى جانب الدنماركية، لكن اللغات المتاحة تختلف من موعد إلى آخر. اتصل بنا على ‎+45 55 29 28 28." },
      ],
      sources: [FS("دورات الفان (هيئة المرور الدنماركية)", "/privat/chauffoeruddannelser/varebilsuddannelser")],
    },

    "taxi-driver": {
      slug: "سائق-تاكسي-في-الدنمارك",
      danishRequired: true,
      metaTitle: "دورة سائق التاكسي في الدنمارك، شرط اللغة الدنماركية | Votra",
      metaDescription:
        "لا يمكن أداء دورة تأهيل سائق التاكسي الدنماركية إلا بالدنماركية: يشترط القانون إتقان الدنماركية بمستوى Prøve i Dansk 2. هذه هي القواعد وكيف تستعدّ.",
      h1: "أن تصبح سائق تاكسي في الدنمارك، اقرأ هذا أولًا",
      short: "مهم: لا يمكن أداء دورة التاكسي بالعربية. إتقان الدنماركية بمستوى Prøve i Dansk 2 شرط قانوني.",
      answer:
        "مهم: لا يمكن أداء دورة تأهيل سائق التاكسي الدنماركية بالعربية أو الإنجليزية أو الأوكرانية. يشترط القانون أن تتقن الدنماركية بمستوى يعادل Prøve i Dansk 2 قبل أن يُقبل التحاقك بدورة معتمدة. نقول لك ذلك مقدّمًا حتى لا تدفع مقابل دورة لا يمكن قبولك فيها. أما باقي الشروط، السن ورخصة القيادة والدورة والاختبارين، فهي موضّحة أدناه.",
      facts: {
        course: "دورة تأهيل سائق التاكسي (taxi-kvalifikationsuddannelsen)",
        delivery: "تعليم حضوري وحصص قيادة فردية واختبارين. بالدنماركية فقط",
        duration: "74 ساعة على الأقل، تشمل 6 حصص قيادة فردية على الأقل",
        venue: "Votra رينغستيد (Sct. Hansgade 9، الطابق الثاني)، مدرجة في قائمة المقدّمين المعتمدين لدى هيئة المرور",
        certificate: "أساس بطاقة السائق (chaufførkort) التي تصدرها هيئة المرور الدنماركية",
        entry: "الدنماركية بمستوى Prøve i Dansk 2، و21 عامًا عند الاختبارات النهائية، ورخصة فئة B لمدة 3 سنوات على الأقل، وشهادة طبية معتمدة، وحسن السيرة",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "شرط اللغة شرط قانوني",
          paragraphs: [
            "يتطلّب القبول في دورة تأهيل سائق تاكسي معتمدة أن تتقن الدنماركية بمستوى يعادل Prøve i Dansk 2، كما ينص الملحق 4 من اللائحة الدنماركية للتاكسي (taxibekendtgørelsen). ويُوثَّق ذلك عمليًا بشهادة Prøve i Dansk 2 أو بامتحان الدنماركية للصف التاسع في المدرسة الدنماركية الأساسية.",
            "هذه ليست قاعدة من وضع Votra. لا يجوز لأي مقدّم معتمد في الدنمارك قبولك بدونها، ولا يمكن الطعن أمام هيئة المرور في قرار رفض القبول بسبب عدم كفاية اللغة الدنماركية.",
          ],
        },
        {
          h2: "الشروط الأخرى",
          paragraphs: [
            "يجب أن تكون قد أتممت 21 عامًا عند أداء الاختبارات النهائية، وأن تكون حاملًا لرخصة قيادة فئة B لمدة 3 سنوات على الأقل، ولا تُحسب الفترات التي سُحبت فيها الرخصة. ويجب أن تمتد الدورة 74 ساعة على الأقل، منها 6 حصص قيادة فردية على الأقل، وتنتهي باختبار نظري واختبار قيادة عملي.",
            "يتكوّن الاختبار النظري من 30 سؤال اختيار من متعدد في 45 دقيقة، ويلزم 23 إجابة صحيحة على الأقل للنجاح. ويُؤدّى الاختبار العملي في سيارة ويقيّمه مدرّب قيادة معتمد لفئة B، مع تقييم خارجي من مدرّب تابع لمركز معتمد آخر.",
            "أما بطاقة السائق فتصدرها هيئة المرور الدنماركية، التي تقيّم أيضًا حالتك الصحية (شروط المجموعة 2: البصر والسمع وغيرها) وحسن سيرتك. رسم البطاقة 1.700 كرونة دنماركية، وتكلفة الشهادة الطبية نحو 750 كرونة.",
          ],
        },
        {
          h2: "كيف تستعدّ لغويًا",
          paragraphs: [
            "تقدّم Votra أيضًا تحضيرًا لاختبار FVU للدنماركية المستوى 2، مع مدرّس بالذكاء الاصطناعي يشرح بـ 12 لغة، ويقرأ النص بصوت عالٍ، ويمنحك اختبارات تدريبية واقعية. وهي طريقة جيدة لتقوية الدنماركية كتابةً ومحادثةً.",
            "لاحظ أن FVU للدنماركية المستوى 2 وPrøve i Dansk 2 اختباران مختلفان. اتصل بنا على ‎+45 55 29 28 28‏ وسنساعدك في تحديد الطريق الأسرع إلى دورة التاكسي.",
          ],
        },
        {
          h2: "دورات يمكنك أداؤها بالعربية أو الإنجليزية أو الأوكرانية",
          paragraphs: [
            "إذا كان هدفك العمل في النقل الآن، فإن دورات مشغّل النقل للشاحنة والفان متاحة مع مترجم فوري في الاختبار. وهي تؤهّلك لإدارة شركة النقل، وليس فيها شرط اللغة الدنماركية الموجود في دورة التاكسي.",
          ],
        },
      ],
      faq: [
        { q: "هل يمكنني أداء دورة التاكسي بالعربية؟", a: "لا. يتطلّب القبول في دورة تأهيل سائق تاكسي معتمدة إتقان الدنماركية بمستوى يعادل Prøve i Dansk 2. والشرط منصوص عليه في اللائحة الدنماركية للتاكسي، وليس من وضع Votra." },
        { q: "كيف أوثّق مستواي في الدنماركية؟", a: "كقاعدة عامة بشهادة Prøve i Dansk 2 أو بامتحان الدنماركية للصف التاسع في المدرسة الدنماركية الأساسية." },
        { q: "ما الشروط الأخرى؟", a: "أن تكون قد أتممت 21 عامًا عند الاختبارات النهائية، وحاملًا لرخصة فئة B لمدة 3 سنوات على الأقل، وأن تنجح في الاختبارين النظري والعملي، وأن تستوفي شروط الصحة (المجموعة 2) وحسن السيرة لدى هيئة المرور." },
        { q: "كيف يتكوّن الاختبار النظري؟", a: "30 سؤال اختيار من متعدد في 45 دقيقة، ويلزم 23 إجابة صحيحة على الأقل للنجاح. ويُقيّم الاختبار العملي بـ ناجح أو غير ناجح." },
        { q: "كم تكلفة بطاقة السائق؟", a: "1.700 كرونة دنماركية رسمًا لهيئة المرور، والشهادة الطبية نحو 750 كرونة. وسعر الدورة منفصل." },
        { q: "أي دورات Votra يمكنني أداؤها بدون الدنماركية؟", a: "دورات مشغّل النقل للشاحنة والفان، ودورتا سائق الفان VB GU وVB EU. وتوفّر Votra مترجمًا فوريًا في الاختبار بالعربية والإنجليزية والأوكرانية." },
      ],
      sources: [
        FS("دورة تأهيل سائق التاكسي (هيئة المرور الدنماركية)", "/privat/chauffoeruddannelser/taxi-kvalifikationsuddannelsen"),
        FS("شروط بطاقة السائق", "/erhverv/taxi/taxichauffoerer/krav-til-chauffoerkort"),
        { label: "اللائحة الدنماركية للتاكسي (BEK رقم 1244 بتاريخ 26/11/2019)", url: "https://www.retsinformation.dk/eli/lta/2019/1244" },
      ],
    },
  },
};

export default ar;
